import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Main from '../views/Main.vue'
import Products from '../views/Products.vue'
import News from '../views/News.vue'
import Recruit from '../views/Recruit.vue'
import About from '../views/About.vue'
import Search from '../views/Search.vue'
import newsContent from '../views/NewsContent.vue'
import ProductsContent from '../views/ProductsContent.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      { path: '/products', name: 'products', component: Products },
      { path: '/news', name: 'news', component: News },
      { path: '/recruit', name: 'recruit', component: Recruit },
      { path: '/about', name: 'about', component: About },
      { path: '/search', name: 'search', component: Search },
      { path: '/newscontent/:id', name: 'newscontent', component: newsContent, props: true },
      { path: '/productscontent/:id', name: 'productscontent', component: ProductsContent, props: true }
    ]
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  }
})

export default router
